export default "__VITE_ASSET__DycrQYzf__"